import { useIntl } from 'react-intl';

import { useFilterFieldContext } from '../hooks/useFilterFieldContext.js';
import { filterFieldMessages } from '../messages.js';
import { defaultSuggestion } from './Suggestion.sty.js';
import { Suggestion } from './Suggestion.js';
import { SuggestionGroup } from './SuggestionGroup.js';

/**
 * @internal
 */
export function PastedContentSuggestionGroup() {
  const { pastedContentSuggestionValues } = useFilterFieldContext();
  const intl = useIntl();

  if (pastedContentSuggestionValues.length === 0) {
    return null;
  }

  return (
    <SuggestionGroup
      aria-label={intl.formatMessage(
        filterFieldMessages.suggestions.a11y.pastedContent,
      )}
    >
      {pastedContentSuggestionValues?.map((suggestion, index) => (
        <Suggestion
          {...suggestion}
          key={suggestion.value ?? index}
          className={defaultSuggestion}
          data-strato-filter-field-virtual-focus-type="pasted-suggestion"
        />
      ))}
    </SuggestionGroup>
  );
}
